import React, { useState, useEffect, useRef } from 'react';
import { Card, CardContent, Container, CircularProgress, Alert, Grid } from '@mui/material';
import {
  useNavigate,
  useLocation,
  createSearchParams,
} from "react-router-dom";
import { Footer } from '../../components/Footer';
import { useLayoutEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { getFormattedExpirationDate } from '../../components/calculation';
import "../../pages/paymentPage.css";
import Loader from '../../components/Loader';
import Header from '../../components/Header';
import DataServices from '../../components/DataServices';
import SuggestedPlanFn from './suggestedPlan';
import SuggestPlanDetails from './suggestedPlan/suggestPlanDetails';
import PlanTable from './planTable';
import PaytmSDK from './paytmSDK/index.js';
import AlertBox from './alertBox/index.js';
// import NoDataFound from '../../components/NoDataFound.js';
// import ReactConfetti from 'react-confetti';
import Confetti from 'react-confetti'
import { setGlobalState, useGlobalState } from '../../globalStyle/index.js';
import axios from 'axios';
import PaymentModeSelection from './paymentModeSelection.js/index.js';

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};

const PlanDetailsPage = ({ formattype }) => {
  const [width, height] = useWindowSize();
  const search = useLocation().search;
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [msg, setErrorMsg] = useState("");
  const [orderId, setOrderId] = useState("");
  const [paytmMID, setPaytmMID] = useState("");
  const [txnToken, setTxnToken] = useState("");
  const [url, setUrl] = useState("");
  const [suggestedPlan, setSuggestPlan] = useState("");
  const [showOtherPlan, setShowOtherPlan] = useState(false);
  const [checkBoxChecked, setCheckBoxChecked] = useState(false);
  const [formWidth, setFormWidth] = useState('');
  const [status, setIsStatus] = useState("INACTIVE");
  const [message, setMessage] = useState("");
  const [isActivePlan, setIsActivePlan] = useState(false);
  const [firstFrequencyVal, setFirstFrequency] = useState("");
  const [frequencyUnitVal, setFrequencyUnit] = useState("");
  const [firstPaymentVal, setFirstPayment] = useState("");
  const [paymentButtonDisabled, setPaymentButtonDisabled] = useState(false);
  const [isAtom, setIsAtom] = useState(false);
  const [paymentUrls, setPaymentUrls] = useState('');
  const [paymentCase, setPaymentCase] = useState('');
  const [severityMsg, setSeverityMsg] = useState('');
  const [allFrequency, setAllFrequency] = useState({
    firstFrequency: '',
    frequencyUnitValue: '',
    firstPayment: ''
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (width > 1150) {
      setFormWidth('50%');
    } else {
      setFormWidth('100%')
    }
  }, [width]);

  let client_code = new URLSearchParams(search).get("clientCode");
  let client_mobile = new URLSearchParams(search).get("mobile");
  let client_email = new URLSearchParams(search).get("client_email");
  let product_plan_id = new URLSearchParams(search).get("product_plan_id");
  let first_name = new URLSearchParams(search).get("first_name");
  let return_url = new URLSearchParams(search).get("return_url");
  let paymentGateway = new URLSearchParams(search).get("paymentGateway");
  let gst = new URLSearchParams(search).get("gst");
  let client_name = new URLSearchParams(search).get("first_name");
  let city = new URLSearchParams(search).get("city");
  let state = new URLSearchParams(search).get("state");
  let pincode = new URLSearchParams(search).get("pincode");
  let address = new URLSearchParams(search).get("address");
  let referCode = new URLSearchParams(search).get("referCode") || new URLSearchParams(search).get("refer_code");
  let IsFormattype = formattype;
  const [selectedRadio, setSelectedRadio] = useState('UPI');
  const planCardRef = useRef(null);
  const [changeNote, setChangeNote] = useState(false);
  const [firstPaymentNote, setFirstPaymentNote] = useState(false);
  const [initialState, setInitialState] = useState({});
  const [paymentMethod, setPaymentMethod] = useState("");
  const [hasUserKycCompleted, setIsUserKycDone] = useState(false);
  const [countDown, setCountdown] = useState(10);
  const [couponCodeUpdatedDetails, setCouponCodeDetails] = useState({});
  const [showConfetti, setShowConfetti] = useState(false);
  const [isCouponCodeDisplay, setIsCouponCodeDisplay] = useState(false);
  const leadSquaredData = useGlobalState("leadSquaredDataVal")[0]
  const productPlanId = useGlobalState("selectedPlanId")[0];
  const ogPlanId = useGlobalState("ogPlanId")[0];
  const isValidCouponCode = useGlobalState("isValidCouponCode")[0];
  const suggestedPlanId = useGlobalState("suggestedPlanId")[0];
  const urlSearchParams = new URLSearchParams(window.location.search);
  const leadBody = useGlobalState("leadSquaredDataVal")[0];
  const paymentBaseUrl = useGlobalState("PAYMENTBASEURL")[0];
  const allowUsers = useGlobalState("ALLOWUSERSCRIPTURL")[0];
  const productMainUrl = useGlobalState("PRODUCTMAINURL")[0];
  const authorizereqUrl = useGlobalState("AUTHORIZEREQURL")[0];
  const verifyUrl = useGlobalState("VERIFYUSERS")[0];
  const subscriptionStatusCheckUrl = useGlobalState("SUBSCRIPTIONSTATUSCHECK")[0];
  


  useEffect(() => {
    if (suggestedPlanId) {
      setCheckBoxChecked(false)
    }
  }, [suggestedPlanId]);


  const handleCouponCode = () => {
    setIsCouponCodeDisplay(!isCouponCodeDisplay)
  }
  
  useEffect(() => {
    const newPaymentUrls = `${paymentBaseUrl}/api/payments/${paymentGateway}/${checkBoxChecked && suggestedPlan && suggestedPlan.recurring
      ? 'subscription' : !checkBoxChecked && selectedPlan && selectedPlan.recurring
        ? 'subscription' : 'onetime'}`;
    const returnUrlParams = { ...leadSquaredData };
    let modifiedReturnUrl = return_url;

    if (checkBoxChecked && !suggestedPlan.recurring) {
      modifiedReturnUrl = return_url.replace("/subscription/", "/onetime/");
    } else {
      modifiedReturnUrl = return_url;
    }
    const returnUrls = `${(modifiedReturnUrl.replace(/\?$/, "") + '?')}${Object.entries(returnUrlParams)
      .filter(([key, value]) => value !== null && value !== "" && value !== "null")
      .map(([key, value]) => `${key}=${value}`)
      .join("&")}`;
      
    setPaymentUrls(newPaymentUrls);
    setInitialState({
      client_code,
      client_mobile,
      client_email,
      first_name,
      product_plan_id: productPlanId,
      return_url: returnUrls,
      paymentMethod,
      paymentGateway: paymentCase,
      gst,
      couponCode: couponCodeUpdatedDetails.coupon_code || "",
      client_name,
      city,
      state,
      payment_mode: selectedRadio,
      pincode,
      address,
      referCode
    });
  }, [
    checkBoxChecked,
    suggestedPlan,
    selectedPlan,
    paymentCase,
    paymentBaseUrl,
    couponCodeUpdatedDetails,
    search,
    client_code,
    client_mobile,
    client_email,
    first_name,
    product_plan_id,
    return_url,
    paymentMethod,
    gst,
    client_name,
    city,
    state,
    selectedRadio,
    pincode,
    productPlanId,
    address,
  ]);



  const countdownAndReload = (count) => {
    if (count === 0) {
      window.location.reload();
    } else {
      setCountdown(count);
      setTimeout(() => countdownAndReload(count - 1), 1000); // Countdown every 1 second
    }
  };

  const reload = () => {
    setTimeout(() => countdownAndReload(countDown), 100); // Start the countdown after 10 seconds
  };

  useEffect(() => {
    IsFormattype = formattype;
  }, [formattype]);

  useEffect(() => {
    if (!initialState.client_email || !initialState.client_mobile) {
      setLoader(false);
      // setIsOpen(true)
    } else if (!initialState.product_plan_id) {
      setLoader(true);
      navigate({
        pathname: "/",
        search: `?${createSearchParams({
          ...initialState,
          paymentMethod: paymentMethod,
          paymentGateway: "paytm",
          ...leadBody,
        })}`,
      });
    } else {
      setLoader(false);
      setIsOpen(false);
    }
  }, [initialState]);

  useEffect(() => {
    if (couponCodeUpdatedDetails && couponCodeUpdatedDetails.coupon_code) {
      setShowConfetti(true);
    }
  }, [couponCodeUpdatedDetails]);


  useEffect(() => {
    if (initialState.client_code || initialState.client_mobile && allowUsers&& authorizereqUrl,verifyUrl) {
      onlyAllowUser();
    }
  }, [initialState.client_code, initialState.client_mobile,allowUsers,authorizereqUrl,verifyUrl])

  const onlyAllowUser = async () => {
    try {
      let clientCodeMobile = initialState.client_mobile!= '' ? initialState.client_mobile : initialState.client_code;
      // Call the API and handle the response
      const response = await DataServices.getVerifyUserData(clientCodeMobile,authorizereqUrl,verifyUrl);
      const result = response || []; // Fallback to an empty array if result is undefined

      // Check if result has data
      if (result.length > 0) {
        setIsUserKycDone(result[0].isKYCCompleted);
      } else {
        setIsUserKycDone(false);
      }
    } catch (error) {
      console.error('Error verifying user data:', error);
      setIsUserKycDone(false); // Default to false in case of error
    }
    const allowUserResult = await DataServices.allowUser(initialState.client_code || initialState.client_mobile, paymentBaseUrl,allowUsers);
    if (allowUserResult && allowUserResult.hasError) {
      let responseAllowUserScript;
      let isValidCode = false;
      responseAllowUserScript = await axios.get(allowUsers);
      if (responseAllowUserScript) {
        const isMobileIncluded = responseAllowUserScript && responseAllowUserScript.data.includes(initialState.client_mobile);
        const isClientCodeIncluded = responseAllowUserScript && responseAllowUserScript.data.includes(initialState.client_code);
        isValidCode = isMobileIncluded || isClientCodeIncluded;
      } else if (initialState.client_code) {
        isValidCode = responseAllowUserScript && responseAllowUserScript.data.includes(initialState.client_code);
      } else {
        isValidCode = false;
      }
      if (isValidCode) {
        setPaymentButtonDisabled(isValidCode);
        setIsOpen(isValidCode);
        setLoading(loading);
        setErrorMsg("Sorry, you are not allow to subscribed. Kindly contact support@stoxbox.in if needed.")
      } else {
        setPaymentButtonDisabled(false);
        setIsOpen(false);
        setLoading(false);
      }
    } else {
      setPaymentButtonDisabled(!allowUserResult.isAllowed);
      if (!allowUserResult.isAllowed) {
        setErrorMsg("Sorry, you are not allow to subscribed. Kindly contact support@stoxbox.in if needed.")
        setIsOpen(true);
      }
    }
  };

  const updateUserDetailsInDB = async () => {
    await DataServices.storeUserData(client_mobile, client_email)
  }

  useEffect(() => {
    setGlobalState("selectedPlanId", ogPlanId)
  }, [ogPlanId])

  useEffect(() => {
    setInitialState((prev) => ({
      ...prev,
      product_plan_id: checkBoxChecked ? selectedPlan.suggestPlan : productPlanId,
      couponCode: couponCodeUpdatedDetails.coupon_code || "",
    }))
  }, [checkBoxChecked, product_plan_id, couponCodeUpdatedDetails, selectedPlan, productPlanId]);


  useEffect(() => {
    if (url && document.paytm) {
      document.paytm.submit();
    }
  }, [url, initialState]);

  const handleRadioChange = () => {
    setShowOtherPlan(!showOtherPlan);
    if (planCardRef.current) {
      planCardRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };


  useEffect(() => {
    fetchLeadSquaredData();
  }, [initialState]);

  const fetchLeadSquaredData = async () => {
    if (initialState && initialState.product_plan_id && initialState.product_plan_id !== "MENTORBOX_SETTLEMENT_PLAN") {
      await DataServices.leadSquaredDataSave(leadSquaredData, initialState);
    }
  };




  useEffect(() => {
    if (status !== "INACTIVE") {
      setMessage(`You are currently subscribed to ${checkBoxChecked ? (suggestedPlan && suggestedPlan.plan) : (selectedPlan && selectedPlan.plan)}. While you have already taken this plan, feel free to explore other available options.`);
      setIsActivePlan(true);
    } else {
      setIsActivePlan(false);
    }
  }, [status, checkBoxChecked, suggestedPlan, selectedPlan]);

  useEffect(() => {
    if (initialState && initialState.client_code && initialState.product_plan_id && subscriptionStatusCheckUrl) {
      stoxboxSubscriptionCheck(initialState.client_code, initialState.product_plan_id);
    }
  }, [initialState.product_plan_id, checkBoxChecked,subscriptionStatusCheckUrl]);

  const stoxboxSubscriptionCheck = async (clientCode, plan) => {
    if(clientCode.length < 10) {
      setIsStatus('ACTIVE');
      console.log('All KYC Users are subscribed');
    } else {
    const usersData = await DataServices.stoxboxSubscriptionStatus(clientCode, plan,subscriptionStatusCheckUrl);
    if (usersData) {
      setIsStatus(usersData.status);
    }    }
  }

  useEffect(() => {
    if (product_plan_id && productMainUrl) {
      fetchPlanData();
    }

  }, [productPlanId, selectedPlan, couponCodeUpdatedDetails, suggestedPlanId,productMainUrl]);

  useEffect(() => {
    if (product_plan_id) {
      let modifiedProductPlanId = product_plan_id;
      if (modifiedProductPlanId.includes("STOXCALLS")) {
        modifiedProductPlanId = modifiedProductPlanId.replace(/STOXCALLS/g, "PROTIPS");
      }
      setGlobalState("selectedPlanId", modifiedProductPlanId);
      setGlobalState("ogPlanId", modifiedProductPlanId);
    }
  }, []);

  useEffect(() => {
    if (selectedPlan && selectedPlan.suggestPlan && productMainUrl) {
      fetchSuggestedPlanDetails(selectedPlan.suggestPlan);
    }
  }, [selectedPlan, productPlanId,productMainUrl]);

  const fetchPlanData = async () => {
    let isRecurring = "";
    const response = await DataServices.productData(productMainUrl);
    const products = response.products;
    if (products) {
      products.map((proVal) => {
        const planResultChild = proVal.child.find(plan => plan.code === productPlanId);
        if (planResultChild) {
          const paymentGateway = planResultChild.paymentGateway && planResultChild.paymentGateway.toLowerCase();
          setPaymentCase(paymentGateway || "paytm");
          isRecurring = planResultChild.recurring ? "subscription" : "onetime";
          setSelectedPlan(planResultChild);
          setGlobalState('price', planResultChild.afterDiscount);
          setGlobalState('selectedPlanData', planResultChild);
        } else if (proVal.campaigns && proVal.campaigns.length > 0) {
          const campaignsPlanResult = proVal.campaigns.find(plan => plan.code === productPlanId);
          if (campaignsPlanResult) {
            const paymentGateway = campaignsPlanResult.paymentGateway && campaignsPlanResult.paymentGateway.toLowerCase();
            setPaymentCase(paymentGateway || "paytm");
            isRecurring = campaignsPlanResult.recurring ? "subscription" : "onetime";
            setSelectedPlan(campaignsPlanResult);
            setGlobalState('price', campaignsPlanResult.afterDiscount);
            setGlobalState('selectedPlanData', campaignsPlanResult);
            const { firstFrequency, firstPayment, frequencyUnit } = campaignsPlanResult;
            setFirstFrequency(firstFrequency);
            setFrequencyUnit(frequencyUnit);
            setFirstPayment(firstPayment);
            if (allFrequency) {
              setChangeNote(true);
            } else {
              setChangeNote(false);
            }
          }
        }
      });
      setPaymentMethod(isRecurring);
    }
  };


  const fetchSuggestedPlanDetails = async (selectedPlan) => {
    try {
      const response = await DataServices.productData(productMainUrl);
      const products = response.products;
      const suggestedPlanData = products.reduce((acc, product) => {
        const plan = product.child.find(plan => plan.code === selectedPlan);
        if (plan) {
          return { ...plan, product: product.product };
        }
        return acc;
      }, null);
      setSuggestPlan(suggestedPlanData);
      setGlobalState('suggestPlanPrice', suggestedPlanData.afterDiscount);
      setGlobalState('suggestionPlanData', suggestedPlanData);
    } catch (error) {
      throw error;
    }
  };




  if (!selectedPlan) {
    return <div className='no-product'>
      <Loader />
    </div>
  }

  const createUrl = (orderId, MID, REDIRECTION_URL) => {
    const paytmUrl = `${REDIRECTION_URL}?mid=${MID}&orderId=${orderId}`;
    setUrl(paytmUrl);
  }

  const payNow = async () => {
    setLoader(true);
    if (client_mobile && product_plan_id && client_email) {
      try {
        DataServices.callGTMStatus(client_email);
        if (isAtom) {
          initialState.paymentGateway = "atom";
        } else if (checkBoxChecked && suggestedPlan.paymentGateway) {
          initialState.paymentGateway = suggestedPlan.paymentGateway;
        } else if (!checkBoxChecked && selectedPlan.paymentGateway) {
          initialState.paymentGateway = selectedPlan.paymentGateway;
        } else {
          initialState.paymentGateway = "paytm";
        }

        if ((checkBoxChecked && suggestedPlan.recurring) || (!checkBoxChecked && selectedPlan.recurring)) {
          initialState.paymentMethod = "subscription";
        } else {
          initialState.paymentMethod = "onetime";
        };
        if (!hasUserKycCompleted) {
          updateUserDetailsInDB();
        }
        switch (initialState.paymentGateway.toLowerCase()) {
          case "paytm":
            if (!isAtom) {
              try {
                const data = await DataServices.paymentGateway(paymentUrls, initialState);
                if (status !== "ACTIVE" && data && data.meta) {
                  const { txnToken } = await data.meta.body;
                  const { MID, REDIRECTION_URL } = await data.meta;
                  setTxnToken(txnToken);
                  const { orderId } = data;
                  setOrderId(orderId);
                  setPaytmMID(MID);
                  if (paytmMID, orderId) {
                    createUrl(orderId, MID, REDIRECTION_URL);
                  }
                } else {
                  setLoader(false);
                  setIsOpen(true);
                  // reload();
                }
              } catch (err) {
                setIsOpen(true);
                setErrorMsg(err);
                setLoader(false);
                // reload();
              }
            }
            break;

          case "atom":
            try {
              const urls = initialState.return_url.replace(/paytm/g, "atom");
              const data = await DataServices.paymentGateway(`${paymentBaseUrl}/api/payments/atom/onetime`, ({ ...initialState, return_url: urls }));
              if (data && data.meta) {
                const { atomTokenId, merchId } = await data.meta;
                const { redirectUrl } = data;
                if (atomTokenId && merchId) {
                  const options = {
                    atomTokenId: atomTokenId,
                    merchId: merchId,
                    custEmail: 'test.user@gmail.com',
                    custMobile: '8888888888',
                    returnUrl: redirectUrl
                  };
                  loadScript(options);
                } else {
                  setIsOpen(true);
                  setLoader(false);
                }
              } else {
                setIsOpen(true);
                setLoader(false);
                // reload();
              }
            } catch (err) {
              setIsOpen(true);
              setLoader(false);
              setErrorMsg(err);
              // reload()
            }
          case "cashfree":
            try {
              const urls = initialState.return_url.replace(/paytm/g, "cashfree");
              const data = await DataServices.paymentGateway(`${paymentBaseUrl}/api/payments/cashfree/${initialState.paymentMethod}`, ({ ...initialState, return_url: urls }));
              if (data && data.redirectUrl) {
                window.location.href = data.redirectUrl;
              } else {
                // const cf = new window.Cashfree(data.meta.payment_session_id);
                // cf.redirect();
                setLoader(false);
                setIsOpen(true)
                // reload();
              }
            } catch (err) {
              setIsOpen(true);
              setLoader(false);
              setErrorMsg(err);
              // reload();
            }

          default:
        }

      } catch (err) {
        setIsOpen(true);
        setErrorMsg(err);
        setLoader(false);
      }
    }
  };



  const loadScript = async (options) => {
    try {
      const metaTag = document.createElement('meta');
      metaTag.httpEquiv = 'X-Frame-Options';
      metaTag.content = 'SAMEORIGIN';
      document.head.appendChild(metaTag);
      const script = document.createElement('script');
      script.src = 'https://pgtest.atomtech.in/staticdata/ots/js/atomcheckout.js?v=' + Date.now();
      script.async = true;
      script.onload = () => {
        // Now, AtomPaynetz should be available globally
        initializeAtomPaynetz(options);
      };
      document.head.appendChild(script);
    } catch (error) {
      console.error('Error loading Atom Payment Gateway script', error);
    }
  };

  const initializeAtomPaynetz = (options) => {
    if (window.AtomPaynetz) {
      let atom = new window.AtomPaynetz(options, 'uat');
    } else {
      console.error('AtomPaynetz is not available. Make sure the script is loaded correctly.');
    }
  };


  const formattedExpirationDate = getFormattedExpirationDate(selectedPlan, checkBoxChecked, suggestedPlan);


  return (
    <div style={{ width: formWidth, margin: '30px auto' }}>
      {!loader && isOpen && (
        <div style={{ margin: '20px' }}>
          <Alert severity={severityMsg ? severityMsg : "error"} onClose={() => setIsOpen(false)}>
            {msg ? msg : `Sorry something went wrong`}
          </Alert>
        </div>
      )}
      {loader ? (
        <div className="loader">
          <Loader />
          <PaytmSDK url={url} txnToken={txnToken} orderId={orderId} paytmMID={paytmMID} />
        </div>
      ) : (
        <Container sx={{ mt: '2px' }}>
          {IsFormattype === 'custom' && <Header title="Get unbiased stock recommendations at Zero Brokerage to Trade Successfully" />}
          <Card>
            <CardContent>
              {showConfetti && <Confetti width={width} height={height} numberOfPieces={400}
                wind={0.02}
                recycle={false}
                timeout={3000} />}
              <PlanTable
                {...{
                  checkBoxChecked,
                  isuggestPlan: suggestedPlan,
                  selectedPlan,
                  firstFrequencyVal,
                  firstPaymentVal,
                  firstPaymentNote,
                  paymentMethod,
                  changeNote,
                  formattedExpirationDate,
                  initialState,
                  setInitialState,
                  selectedRadio,
                  setSelectedRadio,
                  setIsAtom,
                  paymentButtonDisabled,
                  isActivePlan,
                  message,
                  loading,
                  IsFormattype,
                  payNow,
                  frequencyUnitVal,
                  setErrorMsg,
                  setIsOpen,
                  setSeverityMsg,
                  setCouponCodeDetails,
                  setSelectedPlan,
                  couponCodeUpdatedDetails,
                  isCouponCodeDisplay,
                  setIsCouponCodeDisplay
                }}
              />
              <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                <Grid item xs={12} sm={6} md={9}>
                  {checkBoxChecked ? (
                    suggestedPlan && suggestedPlan.recurring && (
                      <PaymentModeSelection {...{ setSelectedRadio, selectedRadio, setInitialState, initialState, selectedPlan, setIsAtom }} />
                    )
                  ) : (
                    selectedPlan && selectedPlan.recurring && (
                      <PaymentModeSelection {...{ setSelectedRadio, selectedRadio, setInitialState, initialState, selectedPlan, setIsAtom }} />
                    )
                  )}
                </Grid>

                {!isCouponCodeDisplay && (
                  <Grid item xs={12} sm={6} md={3} alignItems="center" justifyContent="center">
                    <div className='pr-coupon-code' onClick={handleCouponCode}>
                      Have a coupon code?
                    </div>
                  </Grid>
                )}
              </Grid>
              <AlertBox isActivePlan={isActivePlan} message={message} />
              <div className="subscribe">
                <LoadingButton
                  fullWidth={IsFormattype === 'custom'}
                  variant="contained"
                  size="small"
                  disabled={isActivePlan || paymentButtonDisabled}
                  onClick={payNow}
                  loading={loading}
                  loadingIndicator={<CircularProgress color="inherit" size={20} />}
                  sx={{
                    height: '38px',
                    backgroundColor: '#563EEC',
                    fontWeight: 700,
                    fontSize: '14px',
                    textTransform: 'none',
                    ':hover': {
                      backgroundColor: '#563EEC',
                    },
                  }}
                >
                  Make Payment
                </LoadingButton>
              </div>
                <div className='pr-note'>
                  {(checkBoxChecked ? suggestedPlan.recurring : selectedPlan.recurring) && !changeNote && (
                    <p className='pr-details-note'>
                      <span style={{ fontWeight: 'bold' }}>Note:</span> Your current mandate with us if any will get cancelled and a new mandate will be created. Subscription amount once paid for StoxCalls is non-transferable and non-refundable.
                    </p>
                  )}
                </div>

                {suggestedPlan && suggestedPlan.suggestPlan !== 'undefined' && !isValidCouponCode && (
                  <SuggestedPlanFn showOtherPlan={showOtherPlan} onRadioChange={handleRadioChange} />
                )}
              {!isValidCouponCode && <SuggestPlanDetails
                isuggestPlan={suggestedPlan}
                planCardRef={planCardRef}
                setCheckBoxChecked={setCheckBoxChecked}
                checkBoxChecked={checkBoxChecked}
                showOtherPlan={showOtherPlan}
                selectedPlan={selectedPlan && selectedPlan}
              />}
            </CardContent>
          </Card>
          {IsFormattype === 'custom' && <Footer />}
        </Container>
      )}
    </div>
  );

};

export default PlanDetailsPage;
